export default __webpack_public_path__ + "static/media/4615.68ab452a.png";